interface ExperimentCondition {
  variable: string;
  value: any;
}

class ConvertExperimentManager {
  /**
   * Triggers a Convert.com goal conversion
   */
  triggerGoal(goalId: string): void {
    if (this.hasConsentedToAnalytics()) {
      const currentWindow = window as any;
      currentWindow._conv_q = currentWindow._conv_q || [];
      currentWindow._conv_q.push(["triggerConversion", goalId]);
    }
  }

  /**
   * Triggers a Convert.com experiment by setting conditions and calling executeExperiment
   */
  triggerExperiment(experimentId: string, condition?: ExperimentCondition): void {
    if (condition) {
      (window as any)[condition.variable] = condition.value;
    }

    const currentWindow = window as any;
    currentWindow._conv_q = currentWindow._conv_q || [];
    currentWindow._conv_q.push({
      what: "executeExperiment",
      params: {
        experienceId: experimentId,
      },
    });
  }

  /**
   * Gets the current variation for an experiment
   */
  getExperimentVariation(experimentId: string): string | null {
    const currentWindow = window as any;

    const expData = currentWindow.convert?.currentData?.experiments?.[experimentId];
    if (expData?.variation_id) {
      return expData.variation_id.toString();
    }

    return null;
  }

  /**
   * Waits for experiment data to become available with a timeout
   */
  async waitForExperimentData(experimentId: string, maxWaitMs = 5000): Promise<string | null> {
    const startTime = Date.now();

    while (Date.now() - startTime < maxWaitMs) {
      const variation = this.getExperimentVariation(experimentId);
      if (variation) {
        return variation;
      }
      await new Promise(resolve => setTimeout(resolve, 200));
    }

    return null;
  }

  /**
   * Checks if user has consented to analytics
   */
  private hasConsentedToAnalytics(): boolean {
    if (typeof window === "undefined") return false;

    // Check CookieHub consent
    const cookieHubWindow = window as any;
    if (cookieHubWindow.cookiehub) {
      const analyticsCategory = cookieHubWindow.cookiehub.getCategory("analytics");
      return analyticsCategory === true;
    }

    return false;
  }
}

export const convertExperiments = new ConvertExperimentManager();
